export const LOCALE_IT = {
  commons: {
    email_address: 'Indirizzo e-mail',
    password: 'Password',
    yes: 'si',
    no: 'no',
    update_data: 'Aggiorna dati',
    close: 'Chiudi',
    confirm: 'Conferma',
    fill_all_the_required_fields:
      'Compilare tutti i campi obbligatori richiesti',
    update: 'Aggiorna',
    create: 'Crea',
    add: 'Aggiungi',
    name: 'Nome',
    surname: 'Cognome',
    phone_number: 'Numero di telefono',
    fiscal_code: 'Numero di telefono',
    groups: 'Magazzino di appartenenza',
    search: 'Cerca...',
    search_enter: 'Cerca (premi invio)',
    reload_data: 'Ricarica dati',
    empty_result: 'Nessun elemento trovato',
    edit: 'Modifica',
    delete: 'Elimina',
    approve: 'Approva',
    not_approve: 'Non approvare',
    actions: 'Azioni',
    notes: 'Note',
    update_password: 'Aggiorna password',
    generate_fac_simile: 'Genera Fac-Simile'
  },
  app_menu: {
    home: {
      title: 'Home'
    }
  },
  confirm_dialog: {
    message: "Sei sicuro di voler effettuare l'operazione?"
  },
  logout_dialog: {
    message: 'Sei sicuro di voler uscire?',
    toast_summary: 'Confermato',
    toast_detail: "Hai effettuato il logout dall'applicazione"
  },
  delete_dialog: {
    message: 'Sei sicuro di voler cancellare'
  },
  delete_toast: {
    summary: 'Eliminazione!',
    detail: 'Operazione effettuata con successo'
  },
  administrators: {
    title: 'Elenco amministratori'
  },
  customers: {
    title: 'Elenco clienti'
  },
  operators: {
    title: 'Elenco operatori'
  },
  customs_offices: {
    title: 'Elenco dogane'
  },
  customs_office: {
    title: 'Dettaglio dogana'
  },
  user: {
    title: 'Dettaglio utente'
  },
  additional_emails: {
    title: 'Elenco email aggiuntive'
  },
  additional_email: {
    title: 'Dettaglio email aggiuntiva'
  },
  devices: {
    title: 'Elenco dispositivi',
    title_created_last_quarter: 'Dispositivi creati negli ultimi 3 mesi',
    title_with_anomalies: 'Dispositivi con anomalie',
    title_expiring: 'Dispositivi con taratura in scadenza'
  },
  device: {
    title: 'Dettaglio dispositivo'
  },
  registers: {
    title: 'Elenco registri'
  },
  register: {
    title: 'Dettaglio frontespizio'
  },
  transmissions: {
    title: 'Elenco trasmissioni'
  },
  device_anomalies: {
    title: 'Elenco anomalie dei dispositivi'
  },
  device_anomaly: {
    title: 'Dettaglio anomalia del dispositivo'
  },
  requests: {
    title: 'Elenco pagine registro'
  },
  request: {
    title: 'Dettaglio pagina registro'
  },
  transmission: {
    title: 'Dettaglio trasmissione'
  },
  notes: {
    title: 'Elenco note'
  },
  filters: {
    title: 'Elenco filtri'
  },
  note: {
    title: 'Dettaglio note'
  },
  filter: {
    title: 'Dettaglio filtro'
  }
}
